import React, { type ReactNode } from 'react';

/**
 * Shopify-style card used across the package editor: a titled header followed by
 * a stacked body of fields. Mirrors the activities editor's local `Card`.
 */
export const PackageCard = ({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}): React.JSX.Element => (
  <section className="rounded-lg border border-zinc-200 bg-white">
    <header className="border-b border-zinc-100 px-5 py-3.5">
      <h3 className="text-sm font-semibold tracking-tight text-zinc-900">{title}</h3>
      {description && <p className="mt-0.5 text-xs text-zinc-500">{description}</p>}
    </header>
    <div className="space-y-5 px-5 py-5">{children}</div>
  </section>
);
